var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwordYelloArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50759 8L0 6.27331L1.98929 4L0 1.72669L1.50759 0L5 4L1.50759 8Z",
    fill: "#FFEC55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwordYelloArrow);
export default __webpack_public_path__ + "static/media/forwordYelloArrow.c280e94ad381e0d2e4d97ac105980c8d.svg";
export { ForwardRef as ReactComponent };